//import eimg1 from '../images/event/1.jpg'

//import elimg1 from '../images/event/img-1.jpg'

//import eSimg1 from '../images/event/1.jpg'

// Structural data only. Titles, human-readable dates and locations live in the
// `events` i18n namespace, keyed by `slug`
// (public/locales/{lng}/events.json > items).
//
// `startDate` / `endDate` are machine-readable ISO dates (Africa/Casablanca)
// used by src/utils/events.js to split upcoming from past activities. Keep them
// in sync with the localized `date` label; an event without them stays listed
// as upcoming.
const Events = [
  {
    Id: "1", eImg: `/Dar-Attaoui/Events/Summer-seasion/single-event-cover.png`, elImg: `/Dar-Attaoui/Events/Summer-seasion/event-cover.png`, eSimg: `/Dar-Attaoui/Events/Summer-seasion/single-event-cover.png`, thumb: "Program", slug: "Summer-seasion", time: "11:30 ~ 13:30", startDate: "2026-07-29", endDate: "2026-07-29", translations: {
      ar: {
        content: [
          {
          type: 'paragraph', text: `دأبت مؤسسة دار محمد عطاوي رحمه الله، منذ انطلاقتها على تنظيم دورات في حفظ كتاب الله و تثبيت المحفوظ مع الإعتناء بالقواعد التجويدية كمواد رئيسية.`},
          {
          type: 'paragraph', text: `كما تتخللها مواد و أنشطة موازية لتقريب الناشئة من كتاب الله و تربيتها على تعاليم الدين الإسلامي الحنيف، `},
          {
          type: 'paragraph', text: `تعنى بفئة الأطفال إلى سن 15 عاما تستهدف طلبة المؤسسة خصوصا و خارجها عموما بما فيهم أطفال الجالية المقيمة بالخارج.`},
]
      },
      fr: {
        content: [
          {
            type: 'paragraph', text: `Depuis sa création, la Fondation Dar Mohammed Attaoui (qu'Allah lui fasse miséricorde) organise des sessions dédiées à la mémorisation du Saint Coran, à la consolidation des acquis et à l'apprentissage des règles du Tajwid, qui constituent les principales matières enseignées.`
          },
          {
            type: 'paragraph', text: `Ces sessions sont également enrichies par des activités éducatives et culturelles visant à rapprocher les jeunes du Livre d'Allah et à les éduquer selon les nobles enseignements de l'islam.`
          },
          {
            type: 'paragraph', text: `Elles s'adressent aux enfants jusqu'à l'âge de 15 ans et sont ouvertes en priorité aux élèves de la fondation, tout en accueillant également les enfants extérieurs, y compris ceux de la diaspora marocaine résidant à l'étranger.`
          },
        ]
      },
      en: {
        content: [
          {
          type: 'paragraph', text: `Since its establishment, the Dar Mohammed Attaoui Foundation (may Allah have mercy on him) has been organizing programs focused on Quran memorization, strengthening memorized portions, and mastering the rules of Tajweed as the core areas of study.`},
          {
          type: 'paragraph', text: `These programs are complemented by educational and extracurricular activities designed to help children develop a closer connection with the Holy Quran and grow according to the values and teachings of Islam.`},
          {
          type: 'paragraph', text: `The programs are intended for children up to the age of 15. They primarily serve students of the foundation while also welcoming children from outside the institution, including members of the Moroccan diaspora living abroad.`},
]
      },
    },
    progress: "0", raised: "0.00", goal: "0.00"
  },
];

export default Events;
